// colors used on the website

const colors = {
  primary: '#33CCCC',
  secondary: '#000',
  tertiary: '#fff',
  quaternary: ' #282D30',
  background: '#F6F6F6',
  shadow: '#d9d9d9',
  highlight: '#f2f2f2',

  // Text
  styledText: '#33CCCC',
  darkGrey: '#284646',
  Zircon: '#DBE1E1',
 
  // back to top button colors
  topButtonMain: '#6699cc',
  topButtonHover: '#cc3399',

 // night mode colors
  mainBackgroundDarkMode: '#2F2E41',
  darkModeHighlights: '#4F4C6B',

}



export default colors


